var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"styles",rawName:"v-styles:[callback]",value:(_vm.image),expression:"image",arg:_vm.callback}],ref:"pictureItems",staticClass:"v-picture-items"},[_c('img',{attrs:{"src":_vm.image}})])
}
var staticRenderFns = []

export { render, staticRenderFns }